module.exports = __webpack_public_path__ + "static/media/imgGallery6.5e653076.jpg";